<app-breadcrumb [master]="'Wyniki konkursów'" [parentName]="'Import danych'" [name]="'Import'"></app-breadcrumb>

<div class="commission-import" fxLayout="column" fxLayoutGap="15px" *ngIf="(userPermissions | async).marketing.read_report">

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <mat-card fxLayout="column" fxLayoutGap="15px" [formGroup]="competitionImportForm">
        <div fxLayout="row">
          <h3>Dane importu</h3>
        </div>

        <app-file-drag-and-drop
          [multiple]="false"
          [generateOutput]="true"
          (fileSelected)="fileSelected($event)"
          [maxSize]="fileMaxSize"
          acceptMime="text/csv"
          fxFlex="100">
        </app-file-drag-and-drop>

        <mat-error *ngIf="competitionImportForm.get('fileContent').hasError('backendError')">
          {{competitionImportForm.get('fileContent').getError('backendError')}}
        </mat-error>

        <mat-form-field fxFlex="100">
          <mat-label>Nazwa konkursu</mat-label>
          <input matInput placeholder="Nazwa konkursu" formControlName="competitionName" [required]="true">
        </mat-form-field>

        <mat-form-field fxFlex="100">
          <mat-label>Konkurs rozliczany na</mat-label>
          <mat-select [formControl]="typeControl" [required]="true" [multiple]="false">
            <mat-option value="partner">
              Partner
            </mat-option>
            <mat-option value="ofwca">
              OFWCA
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
          <button *ngIf="(userPermissions | async).marketing.read_report"
                  (click)="import()"
                  [class.spinner]="processingRequest"
                  [disabled]="!competitionImportFormValid"
                  mat-stroked-button color="primary">
            <mat-icon>publish</mat-icon>
            <span> Importuj</span>
          </button>
        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="column" fxFlex="100" *ngIf="this.imported">
    <mat-card *ngIf="previewColumns.length" fxLayout="column" fxLayoutGap="20px">
      <h3>Mapowanie kolumn</h3>

      <table mat-table [dataSource]="previewColumns" class="full-width">
        <ng-container matColumnDef="matched">
          <th mat-header-cell *matHeaderCellDef>Dopasowano?</th>
          <td mat-cell *matCellDef="let col">
            <button *ngIf="col.matched" mat-icon-button>
              <mat-icon class="positive-icon">check_circle</mat-icon>
            </button>
            <button *ngIf="!col.matched" mat-icon-button>
              <mat-icon class="negative-icon">cancel</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="column">
          <th mat-header-cell *matHeaderCellDef>Kolumna źródłowa</th>
          <td mat-cell *matCellDef="let col">
            <strong>{{ col.column }}</strong>
          </td>
        </ng-container>

        <ng-container matColumnDef="preview">
          <th mat-header-cell *matHeaderCellDef>Podgląd wartości</th>
          <td mat-cell *matCellDef="let col">
            <div class="preview-values">
              <div *ngFor="let value of col.values | slice:0:3">
                {{ value ?? '—' }}
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="additional_field">
          <th mat-header-cell *matHeaderCellDef>Pole</th>
          <td mat-cell *matCellDef="let col">
            <div style="max-height: 60px; overflow: hidden;">
              <app-dict-additional-fields
                fxFlex="100"
                label="Pole"
                [formControl]="col.control.get('targetField')">
              </app-dict-additional-fields>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['matched', 'column', 'preview', 'additional_field']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['matched', 'column', 'preview', 'additional_field'];"></tr>
      </table>

      <div fxLayout="column" fxLayoutGap="15px" style="margin-top: 20px;">
        <mat-slide-toggle [formControl]="ignoreNotMatchedFields">
          Nie importuj nieprzypisanych kolumn
        </mat-slide-toggle>

        <div fxLayout="row" fxLayoutGap="15px">
          <button (click)="sendForm()"
                  [class.spinner]="processingRequest"
                  [disabled]="!mappingFormValid"
                  mat-stroked-button color="primary">
            <mat-icon>save</mat-icon>
            <span> Zaimportuj dane</span>
          </button>

          <button tabindex="-1" (click)="deleteImport(competitionImport)" mat-stroked-button color="warn">
            <mat-icon>cancel</mat-icon>
            <span> Anuluj</span>
          </button>
        </div>
      </div>
    </mat-card>
  </div>

</div>
